export const DASHBOARD = 'Dashboard';
export const DATA_MANAGER = 'Data Manager';
export const FIVE_DAY_NOTICE = 'Five Day Notice';